import { AVAILABILITY_SLOTS, LOADING } from "../actionType/availabilityType";

const initialState = {
  loading: false,
  availabilitySlots: [],
};

const availabilityReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AVAILABILITY_SLOTS:
      return { ...state, availabilitySlots: payload };
    case LOADING:
      return { ...state, loading: payload };
    default:
      return state;
  }
};

export default availabilityReducer;
